import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../../lib/growthbook';

export default function useUltraExperienceGuard(): boolean {
  const history = useHistory();

  const isUltraExperienceEnabled = useIsGrowthBookEnabled()
    ? getFiGrowthBook().getFeatureValue<boolean>('ultra-experience', false)
    : false;

  useEffect(() => {
    if (!isUltraExperienceEnabled) {
      history.replace(AppPaths.Products('smart-collar-v3b'));
    }
  }, [isUltraExperienceEnabled, history]);

  return isUltraExperienceEnabled;
}
